import HrEmployeeListPage from "./HrEmployeeListPage";

export default HrEmployeeListPage;